import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=6283aaf3&scoped=true"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"
import style0 from "./CategoryForm.vue?vue&type=style&index=0&id=6283aaf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283aaf3",
  null
  
)

export default component.exports